module.exports = __webpack_public_path__ + "media/images/btn_icon_registration-3cc78e35c545fe3a33f1aa9704b14748.png";